define('Inquiry.ei1.Main.View', [
    'PageType.Base.View',
    'inquiry_page.tpl',
    'GeneralInquiry.ei1.Main.View'
], function (
    PageTypeBaseView,
    inquiry_page_tpl,
    GeneralInquiryView
) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: inquiry_page_tpl,

        beforeShowContent: function beforeShowContent() {
            this.childViews = {
                'GeneralInquiry.ei1.Main.View': function () {
                    return new GeneralInquiryView();
                }
            };
            return jQuery.Deferred().resolve();
        }
    });
});
